import { applyMiddleware, compose, createStore } from 'redux';
import penderMiddleware from 'redux-pender';
import modules from './modules';

const isDev = process.env.NODE_ENV === 'development' || process.env.MODE_ENV === 'staging';

const devTools = isDev && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
const composeEnhancers = devTools || compose;
const middlewares = [penderMiddleware()];

const configure = preloadedState =>
  createStore(modules, preloadedState, composeEnhancers(applyMiddleware(...middlewares)));

export default configure;



// WEBPACK FOOTER //
// ./src/store/configure.js